var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.97 8.833c-8.389-8.389-22.038-8.389-30.427 0L27.329 24.047l3.58 3.58 15.213-15.214A16.453 16.453 0 1169.391 35.68L54.177 50.895l3.579 3.58L72.97 39.26c8.39-8.389 8.39-22.039 0-30.428zM36.289 68.794a16.453 16.453 0 01-23.268-23.268l14.319-14.32-3.58-3.58-14.319 14.32a21.516 21.516 0 1030.428 30.428l14.319-14.32-3.58-3.58-14.319 14.32z",
    fill: "#24FF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.075 57.16l35.798-35.798 3.58 3.58-35.798 35.797-3.58-3.58z",
    fill: "#24FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.8c4200810e576278c4552db16e9ff65e.svg";
export { ForwardRef as ReactComponent };